export default "__VITE_ASSET__B2e9c6SG__"